import { Component, DestroyRef, inject, Inject, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';

import { NodeFarmtypeUtil } from 'src/app/domainObjects/nodeRunStatus';
import { KeyboardDirective } from 'src/app/views/directive/core/keyboard/keyboard.directive';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';
import { TransformDefaultTypeUtil, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';

@Component({
  selector: 'app-run-node-dialog',
  templateUrl: './run-node-dialog.component.html',
  styleUrls: ['./run-node-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RunNodeDialogComponent extends BaseComponent{
  private readonly destroyRef = inject(DestroyRef);

  nodeName!: string;
  farmTypeColor!: string;
  runType!: string;
  totalRefineryRunTime: any = '00:00:00.000';
  returnData: any[] = [];

  nodeFarmtypeUtil = NodeFarmtypeUtil;
  TransformTypeUtil=TransformDefaultTypeUtil;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private keyboardService: KeyboardService,
    private dialogRef: MatDialogRef<RunNodeDialogComponent>,
    private elRef: ElementRef,
    errorLogger: ErrorReportingService,
    matDialog: MatDialog
  ) {super(errorLogger, matDialog);}

  ngOnInit(): void {
    this.returnData = this.data?.runNodeResponse ?? [];
    this.farmTypeColor = this.data?.farmTypeColor ?? '';
    this.nodeName = this.data?.nodeName ?? '';
    this.runType = this.data?.runType ?? '';
    console.log("his.runType ",this.runType)
    this.totalRefineryRunTime = this.data?.totalRunTimeTaken ?? '';
     this.keyboardService.onKey('Escape', () => {
    this.cancel();
  }, this.destroyRef);
  }

  cancel(): void {
    this.dialogRef.close();
  }
  saveAsPDF(): void {
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      const dialogEl: HTMLElement = this.elRef.nativeElement;
      const actionsEl = dialogEl.querySelector('mat-dialog-actions') as HTMLElement;

      if (actionsEl) actionsEl.style.display = 'none';

      const pdfStyle = document.createElement('style');
      pdfStyle.id = 'pdf-override';
      pdfStyle.textContent = `
        app-run-node-dialog table { border-collapse: collapse; width: 100%; }
        app-run-node-dialog th, app-run-node-dialog td { border: 1px solid #999 !important; padding: 2px 4px !important; }
      `;
      document.head.appendChild(pdfStyle);

      const whiteOverrides: { el: HTMLElement; prev: string }[] = [];
      dialogEl.querySelectorAll<HTMLElement>('*').forEach(el => {
        const rgb = window.getComputedStyle(el).color;
        const match = rgb.match(/\d+/g);
        if (match) {
          const [r, g, b] = match.map(Number);
          if (r > 200 && g > 200 && b > 200) {
            whiteOverrides.push({ el, prev: el.style.color });
            el.style.color = '#000';
          }
        }
      });

      const loadHtml2Pdf = (): Promise<any> => {
        return new Promise((resolve, reject) => {
          if ((window as any).html2pdf) { resolve((window as any).html2pdf); return; }
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
          script.onload = () => resolve((window as any).html2pdf);
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      const restore = () => {
        if (actionsEl) actionsEl.style.display = '';
        document.getElementById('pdf-override')?.remove();
        whiteOverrides.forEach(({ el, prev }) => el.style.color = prev);
      };

      loadHtml2Pdf().then((html2pdf: any) => {
        html2pdf()
          .set({
            margin: [8, 8, 8, 8],
            filename: `${this.nodeName || 'run-node-report'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
          })
          .from(dialogEl)
          .save()
          .then(restore)
          .catch(restore);
      }).catch(restore);
    }catch (error) {
      console.error('Error printing report:', error);
    }finally {
      busyIndicator.close();
    }
  }
}
